import CarouselAbstr, { CarouselOptions } from '../CarouselAbstr';
import Slide from '../Slide';
import Debouncer from '../../lib/Debouncer';

export default class featureCarousel extends CarouselAbstr {
	constructor(options: CarouselOptions) {
		super(options);
		this.init();
	}

	protected init(): void {
		if (document.querySelector('.__entry.hasPrivacyPolicyForm')) {
			const setCarouselElHeightDebouncer = new Debouncer(() => {
				const headerHeight = document.querySelector('.pageHeader').getBoundingClientRect().height;
				const privacyPolicyFormHeight = document.querySelector('.privacyPolicyForm').getBoundingClientRect().height;
				(document.querySelector('.featureCarousel__frame') as HTMLElement).style.height = `calc(100vh - ${headerHeight}px - ${privacyPolicyFormHeight}px)`;
			});
			window.addEventListener('resize', setCarouselElHeightDebouncer.run);
			setCarouselElHeightDebouncer.runNow();
		}

		const slidesColl = this.carouselEl.getElementsByClassName('featureCarousel__slide');
		for (let i = 0; i < slidesColl.length; i++) {
			const element = slidesColl[i];
			const isActive = i === 0;
			this.slides.push(new Slide({ element, isActive }));
		}
		this.slides.forEach((slide, index) => {
			slide.element.getElementsByClassName('featureCarousel__contentInner')[0]
				.appendChild(this.buildIndicators(index));
		});

		/* const controlPrev = this.carouselEl.querySelectorAll('.slide--prev');
		const controlNext = this.carouselEl.querySelectorAll('.slide--next');

		for (let i = 0; i < controlPrev.length; i++) {
			controlPrev[i].addEventListener('click', (event: MouseEvent) => {
				this.activatePrevIndex();
				this.trackControlEvent(this.eventLabels.previous);
			});
		}

		for (let i = 0; i < controlNext.length; i++) {
			controlNext[i].addEventListener('click', (event: MouseEvent) => {
				this.activateNextIndex();
				this.trackControlEvent(this.eventLabels.next);
			});
		} */

		this.initAutoAdvance();
	}
}
